<div id="dialog-container">
    <h2 mat-dialog-title>Applying Update to writeoffs</h2>
    <mat-dialog-actions id="dialog-body">
      <mat-spinner></mat-spinner>
    </mat-dialog-actions>
  </div>